import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import EnhancedNotificationsCardView from './EnhancedNotificationsCardView';
import EnhancedNotificationDetails from './EnhancedNotificationDetails';
import { formatDateTime, formatDateTimeFromNow } from '../../../../utils/functions';
import SOURCES from '../../../../utils/constants';
import { Tag } from 'antd';

import { useHistory } from 'react-router-dom';

const EnhancedNotificationsList = ({
    isLoading,
    notifications,
    sort,
    setSort,
    viewType,
    onMarkAsRead
}) => {
    const history = useHistory();
    const [notificationDetails, setNotificationDetails] = useState({
        show: false,
        data: null
    });

    const columns = [
        {
            title: "Notification",
            dataIndex: "notifyText",
            key: "notifyText",
            sortType: "Notification",
            render: (text, record) => (
                <div style={{ maxWidth: "400px" }} title={text}>
                    <span className="line-clamp-2">
                        {text}
                        {record.isCustom && (
                            <span
                                className="ml-2 text-xs text-primary font-medium underline cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    history.push(record.link);
                                }}
                            >
                                {record.actionText}
                            </span>
                        )}
                    </span>
                </div>
            )
        },
        {
            title: "Date",
            dataIndex: "createdAt",
            key: "createdAt",
            sortType: "Date",
            render: (text) => (
                <div>
                    {formatDateTime(text)}
                    <br />
                    <small className="text-muted">{formatDateTimeFromNow(text)}</small>
                </div>
            )
        },
        {
            title: "Status",
            dataIndex: "readStatus",
            key: "readStatus",
            sortType: "Status",
            render: (text, record) => (
                <div className="text-center">
                    {text === SOURCES.NOTIFICATION_UNREAD ? (
                        <FontAwesomeIcon
                            icon={faCheck}
                            className={`text-primary cursor-pointer hover:opacity-80 transition-opacity ${record.isCustom ? 'opacity-30 cursor-not-allowed' : ''}`}
                            style={{ fontSize: "20px" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!record.isCustom) onMarkAsRead(record);
                            }}
                            title={record.isCustom ? "Cannot mark as read" : "Mark as Read"}
                        />
                    ) : (
                        <Tag color="success" className="m-0">Read</Tag>
                    )}
                </div>
            )
        }
    ];

    const handleRowClick = (record) => {
        if (record.isCustom) {
            history.push(record.link);
        } else {
            setNotificationDetails({ show: true, data: record });
        }
    };

    return (
        <>
            {notifications && notifications.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={notifications}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={handleRowClick}
                        />
                    ) : (
                        <CommonCardView>
                            {notifications.map((record) => (
                                <EnhancedNotificationsCardView
                                    key={record._id}
                                    record={record}
                                    onCardClick={(record) => setNotificationDetails({ show: true, data: record })}
                                    onMarkAsRead={onMarkAsRead}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No notifications found." />
            )}

            {notificationDetails.show && (
                <CommonDrawer
                    open={notificationDetails.show}
                    setOpen={() => setNotificationDetails({ show: false, data: null })}
                    title="Notification Details"
                    width={"600px"}
                    children={
                        <EnhancedNotificationDetails
                            notification={notificationDetails.data}
                            onMarkAsRead={(record) => {
                                onMarkAsRead(record);
                                setNotificationDetails(prev => ({ ...prev, data: { ...prev.data, readStatus: 'Read' } })); // Optimistic update in detailed view
                            }}
                        />
                    }
                />
            )}
        </>
    );
};

export default EnhancedNotificationsList;
